import { render, staticRenderFns } from "./VploadImg.vue?vue&type=template&id=3aa34046&scoped=true"
import script from "./VploadImg.vue?vue&type=script&lang=js"
export * from "./VploadImg.vue?vue&type=script&lang=js"
import style0 from "./VploadImg.vue?vue&type=style&index=0&id=3aa34046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa34046",
  null
  
)

export default component.exports